<div class="col p-0">
  <div class="search-box">
    <div class="col-auto p-0">
      <button class="btn-bd-empty" (click)="addRow()">{{ 'CONFIGURE.ADD_NEW' | translate }}</button>
    </div>
    <div class="col-auto p-0 mt-4">
      <app-bd-search (searchTextChanged)="onSearchTextChanged($event)"></app-bd-search>
    </div>
  </div>

  <div class="col-12 static-card">
    <bd-light-table #grid [gridData]="gridData || [] | search:searchText" [pageInfo]="pageInfo"
      [fields]="fields" [addNewRow]=true [actionsLast]=true [actions]="actionItems" [inlineAddRow]=true
      (handlerData)="handlerData($event)"></bd-light-table>
  </div>
</div>

<ng-template #delmodal>
  <div class="modal-header bhp-modal-header">
    <h5 class="mt-4 mb-3">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
    <a (click)="modalRef.hide()" data-dismiss="modal" class="cursor"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
  </div>
  <div class="modal-body bhp-modal-body">
    <p class="">
      {{ 'ERROR_MESSAGES.CONFIRMATION.DELETE.RECORD' | translate }}
    </p>
  </div>
  <div class="modal-footer bhp-modal-footer">
    <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd">{{ 'BUTTON.CANCEL' | translate }}</button>
    <button (click)="delete();modalRef.hide()" class="btn-bd-empty">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
  </div>
</ng-template>